import { GenericObject, ProQaMessageTypeLegacyElectron } from '../../common/types';

export const DISCIPLINE_LABEL_ENUM = {
    POLICE: {
        initLabel: 'Police',
        enhancementLabel: 'Police',
    },
    FIRE: {
        initLabel: 'Fire',
        enhancementLabel: 'Fire',
    },
    EMS: {
        initLabel: 'EMS',
        enhancementLabel: 'Medical',
    },
};

export const DISCIPLINE_SELECTOR_SLUGS = {
    POLICE: 'police',
    FIRE: 'fire',
    EMS: 'medical',
};

export const DEFAULT_COS_KEY = 'OTHERS';

export const CALL_PHONE_TYPE_MAP: Record<string, number> = {
    BUSN: 2,
    CELL: 0,
    CNTX: 2,
    COIN: 5,
    MOBL: 0,
    PAY$: 5,
    PBXB: 2,
    RESD: 2,
    SMS: 3,
    TTY: 3,
    VOIP: 8,
    WPH1: 1,
    WPH2: 7,
    WRLS: 0,
    [DEFAULT_COS_KEY]: 4,
};

export const PRO_QA_TYPES_MAP_FOR_LEGACY_ELECTRON: GenericObject<ProQaMessageTypeLegacyElectron> = {
    EMS: 'CAD_PRO_QA',
    FIRE: 'CAD_PRO_QA_FIRE',
    POLICE: 'CAD_PRO_QA_POLICE',
};

export const SESSIONS_INCIDENT_IDS = 'temporaryIncidentIds';
export const INCIDENT_ID_MAX_LENGTH = 30;

export const DRAFT_EVENT_FOCUS_LOSS_RESET_MS = 2000;
